import { Component, Input } from '@angular/core';

@Component({
    selector: 'al-panel',
    template: `
        <p-accordion [multiple]="false" class="al-panel-wrapper">
            <p-accordionTab  class="al-panel-header" [selected]="active" header="{{title}}">
                <ng-content></ng-content>
            </p-accordionTab>
        </p-accordion>
        `
})

export class AlPanelComponent {

    // Set title for Panel header
    @Input() title: string;

    // Set Panel element is active, default is false
    @Input() active: boolean = false;

}
